import React from "react";
import { Link } from "react-router-dom";
import {
  FaBus,
  FaClock,
  FaIdCard,
  FaSnowflake,
  FaShieldAlt,
  FaBell,
  FaArrowRight,
} from "react-icons/fa";
import "./OverviewSection.css";

const OverviewSection = () => {
  const features = [
    {
      icon: <FaBus />,
      title: "22-Seater AC Buses",
      desc: "Modern Toyota Coaster buses built for comfort and reliability.",
    },
    {
      icon: <FaClock />,
      title: "Fixed Schedules",
      desc: "Buses depart on time, every working day, no exceptions.",
    },
    {
      icon: <FaIdCard />,
      title: "Assigned Seats",
      desc: "Every subscriber gets a reserved seat, bus, and pickup point.",
    },
    {
      icon: <FaSnowflake />,
      title: "Comfort First",
      desc: "Air-conditioned interiors for a stress-free commute.",
    },
    {
      icon: <FaShieldAlt />,
      title: "CCTV & Safety",
      desc: "Every bus is monitored; every driver is vetted and trained.",
    },
    {
      icon: <FaBell />,
      title: "SMS Notifications",
      desc: "Real-time updates on schedules, delays, and route changes.",
    },
  ];

  return (
    <section className="staffline-overview">
      <div className="container">

        <div className="staffline-overview-header">
          <span className="staffline-overview-tag">Why StaffLine</span>
          <h2 className="staffline-overview-title">
            Everything You Need for a Stress-Free Commute
          </h2>
          <p className="staffline-overview-desc">
            StaffLine Transport combines reliability, comfort, and technology
            to redefine how workers commute in Ghana.
          </p>
        </div>

        <div className="staffline-overview-grid">
          {features.map((f, i) => (
            <div className="staffline-overview-card" key={i}>
              <div className="staffline-overview-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="staffline-overview-cta">
          <Link to="/about-us" className="staffline-overview-btn">
            Learn More About Us <FaArrowRight />
          </Link>
        </div>

      </div>
    </section>
  );
};

export default OverviewSection;